import {useState} from 'react';

const MAX_CHARS = 200;

const formatLog = (log) => {
    if (Array.isArray(log)) return log.join(' ');

    return String(log);
};

const LogEntry = ({log, index}) => {
    const text = formatLog(log);
    const isLong = text.length > MAX_CHARS;
    const [isExpanded, setIsExpanded] = useState(false);

    const displayText = isLong && !isExpanded ? text.slice(0, MAX_CHARS) + '…' : text;

    return (
        <div
            className={`font-mono break-words px-4 py-1.5 text-[13px] leading-snug text-gray-600 ${
                index % 2 === 0 ? 'bg-gray-50' : 'bg-white'
            } ${isLong ? 'cursor-pointer' : ''}`}
            onClick={isLong ? () => setIsExpanded((prev) => !prev) : undefined}
        >
            <span className='whitespace-pre-wrap'>{displayText}</span>
            {isLong && (
                <span className='ml-2 inline-block rounded bg-gray-200 px-1.5 py-0.5 text-[10px] font-medium text-gray-500'>
                    {isExpanded ? 'less' : 'more'}
                </span>
            )}
        </div>
    );
};

const LogsList = ({logs}) => (
    <div className='-mx-4 flex flex-col'>
        {logs?.map((log, index) => (
            <LogEntry key={index} log={log} index={index} />
        ))}
    </div>
);

export default LogsList;
